import { IAppService } from '../interfaces/services/app-service.interface';
import { IRemindMeService } from '../interfaces/services/remind-me-service.interface';
import { IReviewsService } from '../interfaces/services/reviews-service.interface';
import { ISearchService } from '../interfaces/services/search-service.interface';
import { IServicesHandler } from '../interfaces/services/service-handler.interface';
import { AppService } from './app-service';
import { RemindMeService } from './remind-me-service';
import { ReviewsService } from './reviews-service';
import { RemoteSearchService } from './remote-search-service';
import { LocalSearchService } from './local-search-service';
import { CategoryPageService } from './category-page-service';
import { ICategoryPageService } from '../interfaces/services/category-page-service';
import { ILoginService } from '../interfaces/services/login-service.interface';
import { LoginService } from './login-service';
import { ITrackingService } from '../interfaces/services/tracking-service.interface';
import { IgTagService } from '../interfaces/services/gtag-service.interface';
import { OWTrackingService } from './tracking/ow-tracking.service';
import { GTagTrackingService } from './tracking/gtag-tracking.service';

// -----------------------------------------------------------------------------
export class ServicesHandler {
  private static instance: IServicesHandler;

  public readonly reviewsService: IReviewsService;
  public readonly appService: IAppService;
  public readonly remindMeService: IRemindMeService;
  public readonly categoryPageService: ICategoryPageService;
  public readonly remoteSearchService: ISearchService;
  public readonly localSearchService: ISearchService;
  public readonly loginService: ILoginService;

  // Tracking + gtag are client-only ('use client', XHR / window). They're built
  // lazily via the getters below rather than in the constructor: this handler is
  // also constructed on the server (data fetching / generateMetadata), where the
  // client-only classes are reference stubs and `new` throws. The server path
  // only touches data services, so it never triggers these; useAnalytics (client)
  // does, getting real instances.
  private _owTrackingService: ITrackingService | null = null;
  private _gTagTrackingService: IgTagService | null = null;

  // ---------------------------------------------------------------------------
  constructor(config: any) {
    this.loginService = new LoginService(config);
    this.reviewsService = new ReviewsService(config, this.loginService);
    this.appService = new AppService(config);
    this.remindMeService = new RemindMeService(config);
    this.categoryPageService = new CategoryPageService(config);
    this.remoteSearchService = new RemoteSearchService(config);
    this.localSearchService = new LocalSearchService(config);
  }

  // ---------------------------------------------------------------------------
  public get owTrackingService(): ITrackingService {
    if (!this._owTrackingService) {
      this._owTrackingService = new OWTrackingService();
    }
    return this._owTrackingService;
  }

  // ---------------------------------------------------------------------------
  public get gTagTrackingService(): IgTagService {
    if (!this._gTagTrackingService) {
      this._gTagTrackingService = new GTagTrackingService();
    }
    return this._gTagTrackingService;
  }

  // ---------------------------------------------------------------------------
  public static getInstance(config: any): IServicesHandler {
    if (!this.instance) {
      this.instance = new ServicesHandler(config);
    }

    return this.instance;
  }
}